<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div
  class="task_properties"
  *ngIf="
    assignees != undefined &&
    assignees.length > 0 &&
    assigneeType === TaskAssignmentType.EMPLOYEEGROUP
  "
  fxLayout="row"
  fxLayoutAlign="start start"
>
  <span class="task_properties_title" i18n="assigned to employee-group label@@assignToEmployeeGroup"
    >{assignees.length, plural, =0 {Employee group} =1 {Employee group} other {Employee
    groups}}</span
  >

  <div
    class="task_properties_value"
    *ngIf="getAssigneeLabel(assignees, assigneeType) as assigneeLabel; else unassignedLabel"
  >
    <span id="assigneeLabel">{{ assigneeLabel }}</span>
  </div>
  <ng-template #unassignedLabel>
    <div class="task_properties_value">
      <span id="missingAssigneesLabel" i18n="@@unassigned">Unassigned</span>
    </div>
  </ng-template>

  <div *ngIf="checkMissingAssignments(assignees, assigneeType) as missingCount">
    <div
      id="missingAllGroupsLabel"
      class="missing_userorgroup_label"
      *ngIf="assigneeType === TaskAssignmentType.EMPLOYEEGROUP && missingCount === assignees.length"
    >
      <fa-icon [icon]="faExclamationCircle"></fa-icon>
      <span i18n="@@allGroupsNotFound"
        >{missingCount, plural, =1 {Group not found} other {Groups not found}}</span
      >
    </div>

    <div
      id="missingSomeGroupsLabel"
      class="partialmissing_group_label"
      *ngIf="
        assigneeType === TaskAssignmentType.EMPLOYEEGROUP &&
        assignees.length > 1 &&
        missingCount < assignees.length
      "
    >
      <fa-icon [icon]="faExclamationTriangle"></fa-icon>
      <span i18n="@@someGroupsNotFound"
        >{missingCount, plural, =1 {1 group not found} other {{{missingCount}} groups not
        found}}</span
      >
    </div>
  </div>

  <ng-template #missingAssigneeNoticeBox>
    <div *ngIf="checkMissingAssignments(assignees, assigneeType) as missingCount">
      <div
        class="missing_userorgroup_notice"
        *ngIf="missingCount === assignees.length"
        fxLayout="column"
      >
        <div
          id="missingAllGroupsNotice"
          class="missing_userorgroup_notice_inner"
          *ngIf="assigneeType === TaskAssignmentType.EMPLOYEEGROUP"
          fxLayout="column"
        >
          <div fxLayout="row">
            <fa-icon [icon]="faExclamationCircle"></fa-icon>
            <span i18n="@@allGroupsNotFound"
              >{missingCount, plural, =1 {Group not found} other {Groups not found}}</span
            >
          </div>
          <span i18n="@@allGroupsNotFoundNotice"
            >{missingCount, plural, =1 {The group assigned to the task no longer exists and the task
            therefore cannot be executed.} other {The groups assigned to the task no longer exist
            and the task therefore cannot be executed.}}</span
          >
        </div>
      </div>
      <div
        id="missingSomeGroupsNotice"
        class="partialmissing_group_notice"
        *ngIf="missingCount < assignees.length"
        fxLayout="column"
      >
        <div fxLayout="row">
          <fa-icon [icon]="faExclamationTriangle"></fa-icon>
          <span i18n="@@someGroupsNotFound"
            >{missingCount, plural, =1 {1 group not found} other {{{missingCount}} groups not
            found}}</span
          >
        </div>
        <span i18n="@@someGroupsNotFoundNotice"
          >{missingCount, plural, =1 {1 group assigned to the task no longer exists. Other groups
          are still assigned to the task, therefore the task can be executed.} other
          {{{missingCount}} groups assigned to the task no longer exist. Other groups are still
          assigned to the task, therefore the task can be executed.}}</span
        >
      </div>
    </div>
  </ng-template>
</div>
